import createHistory from 'history/createBrowserHistory';
import isDev from './constants/isDev';

export const basePath = '/services/podat-apellyatsiyu-na-rezultaty-gia/';

export const basename = isDev ? '/' : basePath;

const history = createHistory({ basename });
export default history;
